import React from 'react';
import Link  from 'components/Link';
import { withRouter } from "react-router";
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const CategoriesList = (props) => {
    const {category} = props;

    const setTagManager = (_url) => {
        const title_path = _url.replace('/', '').replace('_', ' ');
        const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
        TagManagerService.menu(title_crumbs, title_crumbs.split('/').pop(), 'Menú Lateral');
    }

    const clickCategory = (_url) => {
        setTagManager(_url);
    }

    if(!(category)) return '';

    const categoryLevels = category.url.split('?')[0].split('/').filter(Boolean);
    const queryString = category.url.split('?')[1];
    const isSearch = categoryLevels[0] === 'busqueda' || category.key;
    const qtyCategories = categoryLevels.length;
    const isDepartaments = (category.url === '') || (isSearch && categoryLevels.length === 0);
    const isCollection = category.url.indexOf('fq=') !== -1;
    const isSubcategory = qtyCategories > 1;
    const isSubcategoryL3 = qtyCategories > 2;
    const isSubcategoryL4 = isSearch && qtyCategories > 3;
    const backUrl = isSubcategory ? '/' + categoryLevels[0] + (isSubcategoryL3 ? '/'+categoryLevels[1] : '') + (isSubcategoryL4 ? '/'+categoryLevels[2] : '') + (queryString ? '?' + queryString : '') : isCollection && categoryLevels.length === 1 ? '/busca?' + queryString : '';

    return(
        <div className="list-wrap">
            <div className={'category-aside-title-wrap'}>
                <h4 className='category-aside-title'>
                    {backUrl && <Link to={backUrl} className="category-aside-back">
                        <i className="font-icn arrow-up"/>
                        {!isSubcategoryL3 && !!category.items && !!category.items.length ? (isSearch || (isCollection && !isSubcategory) ? 'Categorías' : 'Subcategorías') : (isSearch && !isSubcategoryL4 ? 'Subcategorías' : 'Volver')}
                    </Link>}
                    {!backUrl && (isDepartaments ? 'Departamentos' : 'Categorías')}
                </h4>
            </div>
            <nav className={'category-aside-nav'}>
                <ul className={'category-aside-list active '}>
                    {category.items && category.items.map((cat, i) => {
                        const url = cat.url.length ? cat.url : '';
                        return(
                            <li className={"catalog-aside-nav-item category"} key={i}>
                                <Link to={url} className="catalog-aside-nav-link" onClick={() => clickCategory(url)}>
                                    {(cat.name || cat.title)}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </nav>

        </div>

    )
}

export default withRouter(CategoriesList);
